'use client';

import { Suspense, useEffect } from 'react';
import { useRouter, useSearchParams } from 'next/navigation';
import { isAuthenticated, getDashboardPathForRole } from '@/lib/utils/auth';
import LoginForm from '@/components/auth/LoginForm';
import LoginIllustration from '@/components/auth/LoginIllustration';
import { authService } from '@/lib/api/services/auth';

function LoginPageContent() {
  const router = useRouter();
  const searchParams = useSearchParams();
  const loggedOut = searchParams.get('logged_out') === '1';
  const redirect = searchParams.get('redirect');

  useEffect(() => {
    // Xóa flag logging_out khi vào trang login
    if (typeof window !== 'undefined') {
      sessionStorage.removeItem('logging_out');
    }

    let cancelled = false;
    if (loggedOut) return;
    if (!isAuthenticated()) return;

    (async () => {
      try {
        const me = await authService.getCurrentUser();
        if (cancelled) return;
        const role = me?.role;
        const isBoard = Boolean((me as any)?.is_board);
        const isAdmin = String(role || '').toUpperCase() === 'ADMIN' || isBoard;
        const safeRedirect = redirect && redirect.startsWith('/') ? redirect : '';
        const normalizedRedirect = !safeRedirect
          ? ''
          : isAdmin
            ? safeRedirect.replace(/^\/dashboard(\/|$)/, '/admin$1')
            : safeRedirect.replace(/^\/admin(\/|$)/, '/dashboard$1');
        const nextPath =
          normalizedRedirect &&
          (isAdmin ||
            (!normalizedRedirect.startsWith('/admin/staff') &&
              !normalizedRedirect.startsWith('/admin/departments/permissions') &&
              !normalizedRedirect.startsWith('/dashboard/staff') &&
              !normalizedRedirect.startsWith('/dashboard/departments/permissions')))
            ? normalizedRedirect
            : getDashboardPathForRole(role, isBoard);
        router.replace(nextPath);
      } catch {
        if (cancelled) return;
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [loggedOut, redirect, router]);

  return (
    <div className="min-h-screen flex bg-gray-50">
      {/* Left side - Branding */}
      <div className="hidden lg:block lg:w-[45%]">
        <LoginIllustration />
      </div>

      {/* Right side - Login Form */}
      <div className="w-full lg:w-[55%] flex items-center justify-center p-8 bg-white">
        <div className="w-full max-w-md">
          {/* Mobile logo */}
          <div className="flex justify-center mb-8 lg:hidden">
            <img src="/logo_aplaco.png" alt="Aplaco" className="h-16 object-contain" />
          </div>
          {loggedOut ? (
            <div className="mb-4 rounded-md border border-green-200 bg-green-50 px-4 py-3 text-green-800">
              Đăng xuất thành công
            </div>
          ) : null}
          <LoginForm />
        </div>
      </div>
    </div>
  );
}

export default function LoginPage() {
  return (
    <Suspense>
      <LoginPageContent />
    </Suspense>
  );
}
